import {
  updateParcelUI,
  enableTrackingMap,
  disableTrackingMap,
  archiveParcel,
  showFeedbackPrompt,
  updateRouteToSender,
} from './parcelUiActions';

export default function handleParcelStatusUpdate(data, showNotification, makeApiCall) {
  switch (data.status) {
    case 'PENDING':
      updateParcelUI(data, makeApiCall);
      break;
    case 'ASSIGNED':
      updateParcelUI(data, makeApiCall);
      break;
    case 'PICKED_UP':
      updateParcelUI(data, makeApiCall);
      enableTrackingMap(data);
      break;
    case 'IN_TRANSIT':
      updateParcelUI(data, makeApiCall);
      break;
    case 'DELIVERED':
      updateParcelUI(data, makeApiCall);
      disableTrackingMap(data);
      break;
    case 'COMPLETED':
      archiveParcel(data);
      showFeedbackPrompt(data);
      break;
    case 'DROPPED':
      updateParcelUI(data, makeApiCall);
      break;
    case 'CANCELLED':
      updateParcelUI(data, makeApiCall);
      break;
    case 'FAILED':
      updateParcelUI(data, makeApiCall);
      break;
    case 'RETURNED':
      updateRouteToSender(data);
      enableTrackingMap(data);
      break;
    default:
      updateParcelUI(data, makeApiCall);
  }

  return handleParcelStatusUpdate;
}
